module.exports = "images/pdf-big.png";